import { render } from "./RoadMapInitiatives.vue?vue&type=template&id=c0f453ec"
import script from "./RoadMapInitiatives.vue?vue&type=script&lang=js"
export * from "./RoadMapInitiatives.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__